import React from 'react'

const BookingReportComponentLoadable = React.lazy(() => import('./BookingReportComponent'))
const OperationReportComponentLoadable = React.lazy(() => import('./OperationReportComponent'))
const EmployeeReportComponentLoadable = React.lazy(() => import('./EmployeeReportComponent'))
const NotDeliveryReportComponentLoadable = React.lazy(() => import('./NotDeliveryReportComponent'))
const RTOReportComponentLoadable = React.lazy(() => import('./RTOReportComponent'))
const TripPlanReportComponentLoadable = React.lazy(() => import('./TripPlanReportComponent'))
const VehicleReportComponentLoadable = React.lazy(() => import('./VehicleReportComponent'))
const FinanceManifestReportComponentLoadable = React.lazy(() => import('./FinanceManifestReportComponent'))
const NotManifestReportComponentLoadable = React.lazy(() => import('./NotManifestReportComponent'))
const ManifestChargeReportComponentLoadable = React.lazy(() => import('./ManifestChargeReportComponent'))
const TripPlanWaybillReportComponentLoadable = React.lazy(() => import('./TripPlanWaybillReportComponent'))
const CustomerReportComponentLoadable = React.lazy(() => import('./CustomerReportComponent'))
const DeliverySheetReportComponentLoadable = React.lazy(() => import('./DeliverySheetReportComponent'))
const LocateShipmentReportComponentLoadable = React.lazy(() => import('./LocateShipmentReportComponent'))
const CashCollectionReportComponentLoadable = React.lazy(() => import('./CashCollectionReportComponent'))
const WbWiseFleetDetaisReportComponentLoadable = React.lazy(() => import('./WbWiseFleetDetaisReportComponent'))
const PodAvailabilityReportComponentLoadable = React.lazy(() => import('./PodAvailabilityReportComponent'))
const ExemptionReportComponentLoadable = React.lazy(() => import('./ExemptionReportComponent'))
const PfnReportComponentLoadable = React.lazy(() => import('./PfnReportComponent'))
const CustomerInfoReportComponentLoadable = React.lazy(() => import('./CustomerInfoReportComponent'))
const MarkenReportComponentLoadable = React.lazy(() => import('./MarkenReportComponent'))
const DailyActivityRecapReportComponentLoadable = React.lazy(() => import('./DailyActivityRecapReportComponent'))
const MarkenClientReportComponentLoadable = React.lazy(() => import('./MarkenClientReportComponent'))
const MarkenKPIReportComponentLoadable = React.lazy(() => import('./MarkenKPIReportComponent'))
const CustomerComplaintReportComponentLoadable = React.lazy(() => import('./CustomerComplaintReportComponent'))
const CustomerComplaintKpiReportComponentLoadable = React.lazy(() => import('./CustomerComplaintKpiReportComponent'))
const WaybillsNotDeliveredReportComponentLoadable = React.lazy(() => import('./WaybillsNotDeliveredReportComponent'))
const WaybillsNotInvoicedReportComponentLoadable = React.lazy(() => import('./WaybillsNotInvoicedReportComponent'))
const DeliverySLRReportComponentLoadable = React.lazy(() => import('./DeliverySLRReportComponent'))
const MissPickupReportComponentLoadable = React.lazy(() => import('./MissPickupReportComponent'))
const ScanPerformanceReportComponentLoadable = React.lazy(() => import('./ScanPerformanceReportComponent'))
const VehicleTrackingReportComponentLoadable = React.lazy(() => import('./VehicleTrackingReportComponent'))
const IRSShipmentReportComponentComponentLoadable = React.lazy(() => import('./IRSShipmentReportComponent'))
const IRSManifestApprovalReportComponentLoadable = React.lazy(() => import('./IRSManifestApprovalReportComponent'))
const PodBarcodeReportComponentLoadable = React.lazy(() => import('./PodBarcodeReportComponent'))
const FodCodReportComponentLoadable = React.lazy(() => import('./FodCodReportComponent'))

const FinanceManifestWithVehiclesReportComponentComponentLoadable = React.lazy(
  () => import("./FinanceManifestWithVehiclesReportComponent")
);




export {
  BookingReportComponentLoadable, CustomerReportComponentLoadable,
  DeliverySheetReportComponentLoadable, EmployeeReportComponentLoadable, FinanceManifestReportComponentLoadable, ManifestChargeReportComponentLoadable, NotDeliveryReportComponentLoadable, NotManifestReportComponentLoadable, OperationReportComponentLoadable, RTOReportComponentLoadable,
  TripPlanReportComponentLoadable, TripPlanWaybillReportComponentLoadable, VehicleReportComponentLoadable,
  LocateShipmentReportComponentLoadable, CashCollectionReportComponentLoadable, WbWiseFleetDetaisReportComponentLoadable,
  PodAvailabilityReportComponentLoadable, ExemptionReportComponentLoadable, PfnReportComponentLoadable, CustomerInfoReportComponentLoadable,
  MarkenReportComponentLoadable, DailyActivityRecapReportComponentLoadable,
  MarkenClientReportComponentLoadable,
  MarkenKPIReportComponentLoadable,
  CustomerComplaintKpiReportComponentLoadable,
  WaybillsNotDeliveredReportComponentLoadable,
  WaybillsNotInvoicedReportComponentLoadable,
  CustomerComplaintReportComponentLoadable,
  DeliverySLRReportComponentLoadable,
  MissPickupReportComponentLoadable,
  ScanPerformanceReportComponentLoadable,
  VehicleTrackingReportComponentLoadable,
  IRSShipmentReportComponentComponentLoadable,
  IRSManifestApprovalReportComponentLoadable,
  PodBarcodeReportComponentLoadable,
  FinanceManifestWithVehiclesReportComponentComponentLoadable,
  FodCodReportComponentLoadable
}
